module.exports = __webpack_public_path__ + "static/media/posto-logo.f1e46d03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posto-logo.svg
// module id = 1309
// module chunks = 1